import * as React from 'react';
import * as gls from '../../../ap/layout/gls';
import * as styles from '../../../ap/base/styles';
import { appState } from '../../../state/state';
import {observer} from "mobx-react";
import { AddressLookupInputField } from "../../../ap/fields/inputField";
import ManualAddressEntry from "./ManualAddressEntry";

const {voi} = appState;

export interface AddressInputProps {
}

export interface AddressInputState {
  switchingManualToLookup?: boolean
}

export class AddressInputs extends React.Component<AddressInputProps, AddressInputState>{

  constructor(props) {
    super(props);
    this.state = {switchingManualToLookup: false};
  };

  setManualMode = (isManual) => {
    voi.isManualAddressEntry = isManual;
    this.setState({switchingManualToLookup: !isManual});
  };

  switchToAddressLookup = () => {
    this.setManualMode(false);
    if (voi.useClientAddressAsTransacted) {
      voi.propertyBeingTransacted.setValue('');
    }
  };

  switchToManualAddressEntry = () => {
    this.setManualMode(true);
  };

  lookupFailureHandler = () => {
    this.switchToManualAddressEntry();
  };

  public render() {

    if (voi.isManualAddressEntry) {
      return (
        <div id="address-fields">
          <div id="address-non-harmony-div">
            <ManualAddressEntry id="client-address" switchToLookup={this.switchToAddressLookup} />
          </div>
        </div>
      )
    }
    else {
      const { switchingManualToLookup } = this.state;
      return (
        <div id="address-fields">
          <div id="address-non-harmony-div">
            <gls.ContentVerticalContentMargined margin={styles.spacing.verticalBetweenFields}>
              <AddressLookupInputField
                id="client-address"
                fieldState={voi.addressLookup}
                switchToManual={this.switchToManualAddressEntry}
                lookupFailureHandler={this.lookupFailureHandler}
                takeFocus={switchingManualToLookup}
              />
            </gls.ContentVerticalContentMargined>
          </div>
        </div>
      );
    }
  }
}

export default observer(AddressInputs);
